/*
  Nice Candy: sofortiges Feedback auf Hinzufügen-Knöpfen
  Drücken: Knopf drückt sich ein (sofort, noch bevor etwas lädt).
  Loslassen: Knopf federt zurück, heller Impuls ab der Fingerstelle, Zuckerstreusel, am Android-Handy ein kurzer Vibrations-Tick.
  Wegziehen oder Scrollen: nur zurückfedern, keine Streusel (der Browser löst dann auch keinen Klick aus).
  Lange Knöpfe (Produktseite, Kaufleiste): zusätzlich Glanzstreifen, mehr Streusel, kräftigeres Federn.
  Runde Knöpfe (Produktkarten, Pack noch was dazu): fünf Streusel nach oben.
  Knöpfe, die nur das Auswahlfenster für Größen öffnen, bekommen keine Streusel.
  Wer "Bewegung reduzieren" eingestellt hat, bekommt nichts davon.
*/
(function () {
  if (window.ncPressInit) return;
  window.ncPressInit = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var LONG = 'main product-form button[name="add"], .sticky-add-to-cart-button';
  var ROUND = '.quick-add__submit';
  var COLORS = ['#de00ae', '#ff7ad9', '#ffc83d', '#7ad3ff', '#ff7ad9', '#ffc83d', '#de00ae', '#7ad3ff', '#ff7ad9'];
  var active = null; // { btn, round, x, y, opensModal }

  function findButton(target) {
    if (!target || !target.closest) return null;
    var btn = target.closest(LONG + ', ' + ROUND);
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return null;
    return btn;
  }

  function dots(x, y, count, round) {
    for (var i = 0; i < count; i++) {
      var dot = document.createElement('span');
      dot.className = 'nc-press-dot';
      var size = round ? 7 : 8 + Math.random() * 2;
      dot.style.width = dot.style.height = size + 'px';
      dot.style.left = x + 'px';
      dot.style.top = y + 'px';
      dot.style.background = COLORS[i % COLORS.length];
      document.body.appendChild(dot);
      var dx, dy;
      if (round) {
        var a = -Math.PI / 2 + (i - 2) * 0.55 + (Math.random() - 0.5) * 0.3;
        var d = 30 + Math.random() * 12;
        dx = Math.cos(a) * d; dy = Math.sin(a) * d;
      } else {
        var b = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.5;
        var e = 30 + Math.random() * 16;
        dx = Math.cos(b) * e * 1.6; dy = Math.sin(b) * e * 0.9;
      }
      dot.animate(
        [
          { transform: 'translate(-50%,-50%) scale(1)', opacity: 1 },
          { transform: 'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + dy + 'px)) scale(0.35)', opacity: 0 }
        ],
        { duration: round ? 520 : 620, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      ).onfinish = (function (el) { return function () { el.remove(); }; })(dot);
    }
  }

  function release(state) {
    var btn = state.btn;
    btn.classList.remove('nc-press-down');
    var r = btn.getBoundingClientRect();
    var ripple = document.createElement('span');
    ripple.className = 'nc-press-ripple';
    var d = Math.max(r.width, r.height) * 2.2;
    ripple.style.width = ripple.style.height = d + 'px';
    ripple.style.left = (state.x - r.left) + 'px';
    ripple.style.top = (state.y - r.top) + 'px';
    btn.appendChild(ripple);
    setTimeout(function () { ripple.remove(); }, 650);
    if (state.opensModal) return;
    if (navigator.vibrate) { try { navigator.vibrate(state.round ? 12 : 18); } catch (err) {} }
    if (state.round) {
      dots(r.left + r.width / 2, r.top + r.height / 2, 5, true);
    } else {
      var shine = document.createElement('span');
      shine.className = 'nc-press-shine';
      btn.appendChild(shine);
      setTimeout(function () { shine.remove(); }, 650);
      dots(state.x, state.y, 9, false);
    }
  }

  document.addEventListener('pointerdown', function (e) {
    if (e.button !== undefined && e.button !== 0) return;
    var btn = findButton(e.target);
    if (!btn) return;
    var round = btn.matches(ROUND);
    btn.classList.add('nc-press-host');
    btn.classList.add(round ? 'nc-press-round' : 'nc-press-long');
    btn.classList.add('nc-press-down');
    active = { btn: btn, round: round, x: e.clientX, y: e.clientY, opensModal: !!btn.closest('modal-opener') };
  }, { passive: true });

  function cancel() {
    if (!active) return;
    active.btn.classList.remove('nc-press-down');
    active = null;
  }

  document.addEventListener('pointerup', function (e) {
    if (!active) return;
    var state = active;
    active = null;
    var r = state.btn.getBoundingClientRect();
    var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
    if (!inside) { state.btn.classList.remove('nc-press-down'); return; }
    state.x = e.clientX; state.y = e.clientY;
    release(state);
  }, { passive: true });

  document.addEventListener('pointercancel', cancel, { passive: true });
  document.addEventListener('pointermove', function (e) {
    if (!active) return;
    var r = active.btn.getBoundingClientRect();
    if (e.clientX < r.left - 8 || e.clientX > r.right + 8 || e.clientY < r.top - 8 || e.clientY > r.bottom + 8) cancel();
  }, { passive: true });
})();
